module.exports = __webpack_public_path__ + "img/PDPA-6.87e1afea.png";